#import "./CanvasBlockBaseFields.graphql"

fragment RichTextBlockFields on RichTextBlock {
  ...CanvasBlockBaseFields
  body
}
